import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ft-authentication-wrapper',
    templateUrl: './authentication-wrapper.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticationWrapperComponent {

  constructor() { }
}
